import React from 'react'

import {
    Button,
} from '@mui/material';

const CrmButton = (props) => {
    let { variant, color: tempColor, onClick, children, st = {} } = props


    let colorSX
    let color
    switch (tempColor) {//#94a2ad
        case 'crmBlue':
            colorSX = {
                color: '#555',
                borderColor: '#bbb',
                '&:hover': {
                    backgroundColor: '#f5f5f5',
                    borderColor: '#999',
                },
            }
            break;
        case 'crmGray':
            colorSX = {
                backgroundColor: '#94a2ad', // Gray 500
                color: '#fff',
                '&:hover': {
                    backgroundColor: '#7e7e7e', // Darker gray on hover
                },
            }
            break;
        case 'crmOutLinedGray':
            colorSX = {
                borderColor: '#9e9e9e',       // Gray 500
                color: '#000',
                '&:hover': {
                    backgroundColor: '#e9e9e9', // Gray 100
                },
            }
            break;
        case 'crmContainedGray94':
            colorSX = {
                backgroundColor: '#94a2ad',
                color: '#fff',
                '&:hover': {
                    backgroundColor: '#7e8b97',
                },
            }
            break;
        case 'crmOutlinedGray94':
            colorSX = {
                border: '1px solid #94a2ad',
                color: '#94a2ad',
                '&:hover': {
                    backgroundColor: '#f0f4f7',
                    borderColor: '#7e8b97',
                    color: '#7e8b97',
                },
            }
            break;
        default:
            color = tempColor
    }
    let sx = { ...st, ...colorSX }

    return (
        <Button variant={variant} color={color} sx={sx} onClick={onClick}>
            {children}
        </Button>
    )
}

export default CrmButton